<script lang="ts">
	import type { PageData } from './$types'
	import * as AlertDialog from '$lib/components/ui/alert-dialog/index.js'
	import type { PremiumSheetData } from '$lib/server/services/premium/premium.types'
	import { base } from '$app/paths'

	interface Props {
		data: PageData
	}

	let { data }: Props = $props()

	let dialogOpen = $state(false)
	let selectedSheet: PremiumSheetData | undefined = $state()

	function handleOpenModal(sheet: PremiumSheetData) {
		dialogOpen = true
		selectedSheet = sheet
	}

	function handleNavigateToSheet() {
		window.location.href = selectedSheet?.url || base
	}
</script>

<section class="px-6 mb-20 lg:px-8 lg:max-w-screen-xl mx-auto min-h-[60vh]">
	<div class="flex flex-col items-center justify-center my-20">
		<h1 class="text-3xl lg:text-[44px] lg:leading-tight font-bold pb-5">Premium Access</h1>
		<p>Ready to accelerate your investing to a whole new level?</p>
	</div>

	{#if !data?.sheets}
		<div
			class="rounded-xl mx-auto shadow-xl p-10 w-3/4 xl:w-2/3 text-center flex flex-col items-center justify-center"
		>
			<h3 class="text-xl font-bold pb-6">Looking for Premium access?</h3>
			<p>
				Welp! Checkout out our
				<a class="text-lilac-500 hover:underline" href="/#pricing">Premium plan options!</a>
			</p>
			<p class="pt-6">
				If you already have a subscription, you can upgrade your subscription by visiting your <a
					class="text-lilac-500 hover:underline"
					href="/#pricing">account page</a
				>
				and click on the button that says <b>"Manage Plan"</b>.
			</p>
		</div>
	{:else}
		<ul>
			{#each data.sheets as sheet}
				<li>
					<div class="flex gap-4 shadow-xl rounded-xl p-5 mb-10 relative">
						<div class="w-20">
							<img src={sheet.imagePath} alt={sheet.name} />
						</div>
						<button
							class="flex flex-col gap-4 after:absolute after:inset-0 text-left"
							onclick={() => handleOpenModal(sheet)}
						>
							<span class="font-extrabold text-slate-700">{sheet.name}</span>
							<span class="max-w-xl">{sheet?.description ?? ''}</span>
						</button>
					</div>
				</li>
			{/each}
		</ul>
	{/if}
</section>

<AlertDialog.Root
	open={dialogOpen}
	closeOnOutsideClick={true}
	onOpenChange={(state) => {
		dialogOpen = state
	}}
>
	<AlertDialog.Content>
		<AlertDialog.Header>
			<AlertDialog.Title
				>Download the <span class="text-lilac-500">{selectedSheet?.name} </span> sheet</AlertDialog.Title
			>
			<AlertDialog.Description>
				You are about to navigate to a Tickerdata Premium Sheet! In order to use this sheet, do the
				following:
				<ol class="list-decimal list-inside py-4 font-medium">
					<li>Click "Go to sheet"</li>
					<li>Click on "File"</li>
					<li>Under "File", click "Make a Copy"</li>
				</ol>
				If you have any troubles, please see our docs on {' '}<a
					href="/docs"
					class="text-lilac-500/70 hover:underline">troubleshooting!</a
				>
			</AlertDialog.Description>
		</AlertDialog.Header>
		<AlertDialog.Footer>
			<AlertDialog.Cancel>Cancel</AlertDialog.Cancel>
			<AlertDialog.Action onclick={handleNavigateToSheet}>Go to sheet</AlertDialog.Action>
		</AlertDialog.Footer>
	</AlertDialog.Content>
</AlertDialog.Root>
